module.exports = __webpack_public_path__ + "static/12-30327a5fa6972b1a718321c5c2733b4e.jpeg";